import type { InteractionContext } from '@/models/grid/GridInteractionHandler';

export enum TilePlacementStrategyType {
  Line = 'line',
  FreeDraw = 'free-draw',
  Rectangle = 'rectangle',
  Ribbon = 'ribbon',
}

export interface TilePlacementStrategy {
  handlePointerDown: (event: PointerEvent, context: InteractionContext) => void;
  handlePointerMove: (context: InteractionContext) => void;
  handlePointerUp: (event: PointerEvent, context: InteractionContext) => void;
  cancel: () => void;
}
